export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8001';

export const FUEL_TYPES = ['JetA', '100LL', 'JetA_plus'];

export const TRUCK_STATUS = {
  AVAILABLE: 'available',
  IN_USE: 'in_use',
  MAINTENANCE: 'maintenance',
  REFUELING: 'refueling',
  OUT_OF_SERVICE: 'out_of_service',
};

export const TRUCK_STATUS_CONFIG = {
  available: { color: 'text-green-400', bg: 'bg-green-500/20', label: 'Available', icon: '🟢' },
  in_use: { color: 'text-blue-400', bg: 'bg-blue-500/20', label: 'In Use', icon: '🔵' },
  maintenance: { color: 'text-yellow-400', bg: 'bg-yellow-500/20', label: 'Maintenance', icon: '🟡' },
  refueling: { color: 'text-orange-400', bg: 'bg-orange-500/20', label: 'Refueling', icon: '⛽' },
  out_of_service: { color: 'text-red-400', bg: 'bg-red-500/20', label: 'Out of Service', icon: '🔴' },
};

export const FUEL_META = {
  JetA:      { bar: 'bg-blue-500',   badge: 'text-blue-400 bg-blue-500/20',     label: 'Jet-A'      },
  '100LL':   { bar: 'bg-green-500',  badge: 'text-green-400 bg-green-500/20',   label: '100LL Avgas' },
  JetA_plus: { bar: 'bg-purple-500', badge: 'text-purple-400 bg-purple-500/20', label: 'Jet-A Plus' },
};

export const EMPTY_TANK = {
  fuel_type: 'JetA', tank_name: '', capacity_gallons: '',
  current_volume_gallons: '', reorder_level_gallons: '', price_per_gallon: '',
};

export const EMPTY_TRUCK = {
  truck_number: '',
  truck_name: '',
  fuel_type: 'JetA',
  capacity_gallons: '',
  current_volume_gallons: '',
  license_plate: '',
  driver_name: '',
  driver_phone: '',
  status: 'available',
  last_maintenance_date: '',
  next_maintenance_date: '',
  notes: '',
  is_active: true,
};

export const EMPTY_TX = {
  aircraft_id: '', owner_id: '', fuel_type: 'JetA',
  gallons: '', price_per_gallon: '', staff_id: '', truck_id: '',
};

export const EMPTY_DELIVERY = {
  fuel_type: 'JetA', gallons: '', price_per_gallon: '', supplier_name: '', invoice_number: ''
};

export const EMPTY_PRICE = {
  fuel_type: 'JetA', price_per_gallon: ''
};

export const EMPTY_TRUCK_REFILL = {
  gallons: '',
  source_tank_type: 'station',
  truck_meter_before: '',
  truck_meter_after: '',
  staff_id: '',
  notes: '',
};